function appendSuffix(action, suffix) {
  if (typeof action === 'string') return `${action}_${suffix}`;
  if (Reflect.has(action, 'type')) {
    return { ...action, type: `${action.type}_${suffix}` };
  }
  return action;
}

/**
 * Append prefix SUCCESS to the current action type
 * @param {string} action
 * @returns string
 */
function successAction(action) {
  return appendSuffix(action, 'SUCCESS');
}

/**
 * Append prefix FAILURE to the current action type
 * @param {string} action
 * @returns string
 */
function failureAction(action) {
  return appendSuffix(action, 'FAILURE');
}

export { successAction, failureAction };
